import { Locale } from 'date-fns'
import ar from 'date-fns/locale/ar'
import de from 'date-fns/locale/de'
import enGB from 'date-fns/locale/en-GB'
import es from 'date-fns/locale/es'
import fi from 'date-fns/locale/fi'
import fr from 'date-fns/locale/fr'
import he from 'date-fns/locale/he'
import it from 'date-fns/locale/it'
import nb from 'date-fns/locale/nb'
import nl from 'date-fns/locale/nl'
import pl from 'date-fns/locale/pl'
import ro from 'date-fns/locale/ro'
import sk from 'date-fns/locale/sk'
import uk from 'date-fns/locale/uk'
import zhCN from 'date-fns/locale/zh-CN'
import { TFunction } from 'react-i18next'

const DATE_FNS_LOCALES: Record<string, Locale> = {
  ar,
  de,
  en: enGB,
  es,
  fi,
  fr,
  he,
  it,
  nb,
  nl,
  pl,
  ro,
  sk,
  uk,
  zh: zhCN,
}

export const getDateFnsLocaleByLanguage = (language: string): Locale =>
  DATE_FNS_LOCALES[language] || enGB

export const getDateFnsLocale = (
  t: TFunction<'common', undefined>
): Locale => getDateFnsLocaleByLanguage(t('current_language'))
